import React from 'react';
import { useTranslation } from 'react-i18next';
import { localeDate, tz } from '../utils/region';
import { EMAIL_CAL_GROUP, lighten } from '../tabPalette';

// ── Shared "opened" circle ──────────────────────────────────────────────────────────────────────
// In the quotation's or invoice's Doc No. cell once the To: recipient has opened its email
// (Calem, Bugify #bf7d6a54): the image in their copy loaded, or they followed a quotation's confirm
// link. It stood just in front of the client name until Calem, Bugify #5d3f022a: "Move the client
// viewed eye circle to the quotation or invoice number … at the end of the quotation or invoice
// number". A 19px circle, as AwaitingBadge's hourglass was then (Calem, Bugify #43e33304 3rd opening: "Make the
// viewing eye a circular bubble"); it was a wider pill. In the top menu's Email / Contacts / Calendar purple since
// Calem, Bugify #0be6ce7d ("change it to the color purple (email and communications color)"), the purple ✉N badge's
// settled look (see MailBadge): EMAIL_CAL_GROUP.color #7F77DD for the eye and a 1px ring, the box's see-through wash
// laid on white, #F3F2FC, for the fill. Taken from the palette, so it follows the box. The eye reads about 3.4:1 on
// it, a little more than the blue did. Was Quotation-menu blue, as on the Portal tabs: #378ADD on #E6F1FB, the ring
// #185FA5, the blue family's darker step (ACCOUNT_COLORS.blue.hover). Shared, so the email list's read-receipt eye
// turned purple with it — one look for the marker.
// Moved here from Peak so the email list's Sent rows wear the same circle once their read receipt
// comes back (Calem, Bugify #fcd1ede7: "show a little UI in a circle like you do with quotations at the
// end of the sent email list"). `tipKey` is the tooltip's i18n key; `style` places it in its row.
// On the Invoice and Quotation lists it sat straight after the number until Bugify #7c168072, which gave it a
// slot of its own so every row's eye stands at one x, at the cell's right end; just after the page's longest number
// since Bugify #28fd8306 (DocNoEye in Peak).
export default function OpenedBadge({ at, tipKey = 'qo_opened_tip', style }: { at?: number; tipKey?: string; style?: React.CSSProperties }) {
  const { t } = useTranslation();
  if (!at) return null;
  const when = new Date(at * 1000).toLocaleString(localeDate(), { timeZone: tz(), day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false });
  return (
    <span title={t(tipKey, { at: when })}
      style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 19, height: 19, borderRadius: '50%', color: EMAIL_CAL_GROUP.color, background: lighten(EMAIL_CAL_GROUP.tint, 0), border: `1px solid ${EMAIL_CAL_GROUP.color}`, marginRight: 8, verticalAlign: 'middle', ...style }}>
      <i className="ti ti-eye-check" style={{ fontSize: 13 }} aria-hidden />
    </span>
  );
}
